<span>
    {{ control.errors | errorTranslator | async }}
</span>
